export default __webpack_public_path__ + "static/media/vuejs.30c204c5.svg";